import $ from 'jquery'

/**
 * Table Scanner for jQuery taken and modified from <https://stackoverflow.com/a/13426773>
 *
 * Scans a table and sets X/Y position of a cell including row-span and col-span offsets.
 */
const scanTable = $table => {
  let missing = []

  $table.children('tr').each((y, row) => {
    $(row)
      .children('td, th')
      .each((x, cell) => {
        let $cell = $(cell)
        let colSpan = $cell.attr('colspan')
        let rowSpan = $cell.attr('rowspan')
        let tX
        let tY

        colSpan = colSpan || 1
        rowSpan = rowSpan || 1

        for (; missing[y] && missing[y][x]; ++x);

        for (tX = x; tX < x + colSpan; ++tX) {
          for (tY = y; tY < y + rowSpan; ++tY) {
            if (!missing[tY]) {
              missing[tY] = []
            }

            missing[tY][tX] = true
          }
        }

        $cell.data('cellPos', { top: y, left: x })
      })
  })
}

$.fn.cellPos = function (shouldScan) {
  let $cell = this.first()
  let cellPos = $cell.data('cellPos')

  if (!cellPos || shouldScan) {
    scanTable($cell.closest('table, thead, tbody, tfoot'))
  }

  return $cell.data('cellPos')
}
